// Questionnaire (Typeform) ids and answer-choice ids used to identify and
// score the behavioral health screening questionnaires (PHQ-8, GAD-7).
// Shared between the user app (questionnaire flow) and PMP (care team view).

export const BEHAVIORAL_HEALTH_QUESTIONNAIRE_PHQ8: string = "vPliohYa";
export const BEHAVIORAL_HEALTH_QUESTIONNAIRE_GAD7: string = "JvW9N8Bm";
export const BEHAVIORAL_HEALTH_QUESTIONNAIRE_HOW_DIFFICULT_QUESTION_ID =
  "i3YTldsNrt4u";
export const BEHAVIORAL_HEALTH_QUESTIONNAIRE_HOW_DIFFICULT_ANSWER_NOT_DIFFICULT =
  "b3taslRS528V";
export const BEHAVIORAL_HEALTH_QUESTIONNAIRE_HOW_DIFFICULT_ANSWER_SOMEWHAT =
  "eP6mBmOE3wF7";
export const BEHAVIORAL_HEALTH_QUESTIONNAIRE_HOW_DIFFICULT_ANSWER_VERY =
  "b54U0yAocbS6";
export const BEHAVIORAL_HEALTH_QUESTIONNAIRE_HOW_DIFFICULT_ANSWER_EXTREMELY =
  "mdQxCvPcVPoF";
